exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1F_lXtwniB3Ybt{visibility:hidden;position:absolute;bottom:10px;left:15px;height:32px}", ""]);

// exports
exports.locals = {
	"popoverPositioner": "_1F_lXtwniB3Ybt"
};